import styled, { css } from 'styled-components'

export const LocationDot = styled.div<{ $brand?: boolean }>`
  --dot-size: 16px;

  width: var(--dot-size);
  height: var(--dot-size);
  margin-left: calc(var(--dot-size) / -2);
  margin-top: calc(var(--dot-size) / -2);
  padding: 0;

  border: 3px solid white;
  border-radius: 50%;

  background-color: ${({ theme }) => theme.brand.sky};
  box-shadow: 0 0 0 6px rgba(151, 178, 218, 0.35);

  ${({ $brand }) =>
    $brand &&
    css`
      --dot-size: 18px;

      background-color: var(--ds-bg-container-brand);
      box-shadow: 0 0 0 12px rgba(12, 103, 118, 0.22);
    `}
`

type CurrentLocationMarkerProps = {
  /* Consumed by google-map-react to position the marker */
  lat: number
  lng: number
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const CurrentLocationMarker = (_props: CurrentLocationMarkerProps) => (
  <LocationDot aria-label="Your location" role="img" />
)

export default CurrentLocationMarker
